if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      this.inertElements.map((element) => {
        element.removeAttribute('inert');
      });
      window.pauseAllMedia();
      if (this.opener) {
        setTimeout(()=>this.opener.focus(), 100);
      }
    }

    show(opener) {
      this.opener = opener;
      super.show(opener);
      this.inertElements = window.inertOtherElements(this);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const deferredMediaContainer = document.getElementsByTagName('product-modal')[0]?.getElementsByTagName('deferred-media')[0];

      if(deferredMediaContainer.dataset.mediaId) {
        deferredMediaContainer.getElementsByTagName('button')[0]?.click();
        deferredMediaContainer.getElementsByTagName('video')[0]?.play();
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
